import { Action } from "@ngrx/store";

import { LOADING_ACTION_TYPE } from "./loading.action";
import { LoadingState } from "./loading.model";

const initialState: LoadingState = {
	counter: 0,
};

export function loadingReducer(state = initialState, action: Action): LoadingState {
	switch (action.type) {
		case LOADING_ACTION_TYPE.open: {
			return {
				...state,
				counter: state.counter + 1,
			};
		}
		case LOADING_ACTION_TYPE.close: {
			return {
				...state,
				counter: state.counter > 0 ? state.counter - 1 : 0,
			};
		}
		case LOADING_ACTION_TYPE.clear: {
			return {
				...state,
				counter: 0,
			};
		}
		default:
			return state;
	}
}
